import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.getCategoryReport>[0]["queries"];

export const getCategoryReportOptions = (filters: Params) => {
  return queryOptions({
    queryKey: [
      "categoryReport",
      filters.mp,
      filters.start_date,
      filters.end_date,
      filters.pre_start_date,
      filters.pre_end_date,
      filters.date_group,
      filters.category,
    ],
    queryFn: async () => {
      const res = await apiClient.getCategoryReport({ queries: filters });
      return res;
    },
  });
};

export type CategoryReportByCategoryRow = Awaited<ReturnType<typeof apiClient.getCategoryReport>>["categories"][number];
